import React, { Component } from 'react';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import history from '../../../../history';
import {connect} from 'react-redux';
import { CONFIG,URL_AKM } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import akmApi from '../../../../apis/akmApi';
import {Form,Alert} from 'react-bootstrap';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import ProfilCbt from '../../../../entity/ProfilCbtSearch';

class FormProfilCbt extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            profil: ProfilCbt,
            kelas: [],
            kurikulum: [],
            action: 'add',
            alertShow: false,
            resMessage: '',
        };
    }
    fetchKelas = async () => {
        const response = await akmApi.get(URL_AKM.KELAS_GROUP_ALL)
        .catch(function(error){ alert(error)});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
    }
    fetchKurikulum = async () => {
        const response = await akmApi.get(URL_AKM.KURIKULUM_GET_ALL)
        .catch(function(error){ alert(error)});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kurikulum: response.data.data
                })
            }
        }
    }
    
    getById = async() => {
        this.setState({isFetching: true, profil: {} })
        const res = await accountManagement.get(CONFIG.HW_GET_BY_ID + this.props.idProfilCbt).catch(function(error){
        })
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    profil: res.data.data                    
                })
                this.getMapel(res.data.data.idKelas)
            } else {
                this.setState({ resMessage: res.data.errorSchema.errorMessage})
            } 
            this.setState({ isFetching: false });
        } 
        
    }
    async componentDidMount() {
        const init = this.props.location.state.profil;    
        this.setState({isFetching: true})

        await this.props.cekCookies();       
        if(!__.isEmpty(this.props.account)) {            
            this.fetchKelas();
            this.fetchKurikulum();
        }
        if(!__.isEmpty(init)) {
            //this.getById();
            this.setState({
                profil: init,
                action: 'edit'
            })
        } else {
            const tipe = this.props.match.params.tipeCbt;
            this.setState({ 
                profil: {...this.state.profil, kodeTipeCbt: (tipe === 'AN' ? 'ASM' : tipe), kodeSubTipeCbt: tipe }
            })
        } 
        
        this.setState({isFetching: false})
    }
    onChangeKelas = async (data) => {  
        this.setState({ profil: {...this.state.profil, idKelasGroup: data.target.value} })         
    }
    onChangeKurikulum = async (data) => {  
        this.setState({ profil: {...this.state.profil, idKurikulum: data.target.value} })         
    }
    onChangeJudul = async(data) => {
        this.setState({ profil: {...this.state.profil, namaProfil: data.target.value} })
    }
    
    renderKelas(){
        return this.state.kelas.map((kel) => {
            return (
                <option key={kel.idKelasGroup} value={kel.idKelasGroup}>{kel.namaKelasGroup}</option>
            )
        })        
    }

    handleSubmit = async(event) => {
        event.preventDefault();
        this.setState({isFetching: true})
        const res = await akmApi.post(URL_AKM.CBT_PROFIL_POST, this.state.profil).catch(function(error){alert(error)})
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){                
                this.handleBack();                
            } else {
                this.setState({
                    alertShow: true,
                    resMessage: res.data.errorSchema.errorMessage              
                })
            } 
            this.setState({ isFetching: false });
        } 
    }

    
    handleBack() {
        if(this.state.profil.kodeSubTipeCbt === 'AN') history.push({ pathname: '/akm'});
        if(this.state.profil.kodeSubTipeCbt === 'QUEST') history.push({ pathname: '/profil_qs'});
    }
    
    render() { 
        const {profil, action} = this.state; 
        let pageTitle;
        if(action === 'edit') {
            pageTitle = "Edit Profil";
        } else {
            pageTitle = "Add Profil";
        }
        
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={pageTitle}/> 
                    {this.loadAlert()}
                    
                    <Form onSubmit={this.handleSubmit}>                    
                    <Form.Group controlId="nama">
                        <Form.Label>Judul Profil : </Form.Label>
                        <Form.Control
                        type="text"
                        name="namaProfil" 
                        defaultValue={profil.namaProfil} onChange={this.onChangeJudul}                                 
                        placeholder="Input Judul..." required/>
                    </Form.Group>
                    <Form.Group controlId="kelas">
                        <Form.Label>Kelas :</Form.Label>
                        <select className="form-control" name="idKelas" value={profil.idKelasGroup} required onChange={this.onChangeKelas}>
                            <option value="">Pilih Kelas...</option>
                            {this.state.kelas.map((kel) =>            
                                <option key={kel.idKelasGroup} value={kel.idKelasGroup}>{kel.namaKelasGroup}</option>
                            )}
                        </select>
                    </Form.Group>
                    <Form.Group controlId="kurikulum">
                        <Form.Label>Kurikulum :</Form.Label>
                        <select className="form-control" name="kurikulum" value={profil.idKurikulum} required onChange={this.onChangeKurikulum}>
                            <option value="">Pilih Kurikulum...</option>
                            {this.state.kurikulum.map((item) =>            
                                <option key={item.idKurikulum} value={item.idKurikulum}>{item.namaKurikulum}</option>
                            )}
                        </select>
                    </Form.Group>                        
                    <Form.Group>
                        <Form.Control type="hidden" name="idProfilCbt" value={profil.idProfilCbt} />
                        {/* <Form.Control type="hidden" name="kodeTipeCbt" value="EXAM" /> */}
                        <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}><ArrowBackIosIcon fontSize="small"/>Batal</button>
                                
                        <button type="submit" className="btn btn-primary pull-right">Simpan</button>
                    </Form.Group>
                    </Form>
                 

                </div>
            </div>              
        );
    }

    loadAlert = () => {
        const {alertShow } = this.state;      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }  
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}

export default connect(mapStateToProps, {cekCookies})(FormProfilCbt);